var map = {
	"./0-stars.webp": "2be1",
	"./1-stars.webp": "5f3c",
	"./2-stars.webp": "14f6",
	"./3-stars.webp": "6195",
	"./4-stars.webp": "0679",
	"./5-stars.webp": "59ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ab0";